export default "__VITE_ASSET__1b22cc94__"